// extracted by mini-css-extract-plugin
module.exports = {"header":"index_header__Nm_jX","main":"index_main__0HZI8","mainItem":"index_mainItem__P25Ik","head":"index_head__VSxl5","desc":"index_desc__9nsau"};